"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayedFilterValue = void 0;
const lodash_1 = require("lodash");
const luxon_1 = require("luxon");
/**
 * Gets a displayable value from a filter value for the FilterChip component
 *
 * @param {(string|string[]|number|number[]|Object|Object[]|boolean)} value The value to be transformed
 * @returns {string} Displayable value for the FilterChip component
 */
const getDisplayedFilterValue = (value) => {
    if ((0, lodash_1.isObject)(value)) {
        if (luxon_1.DateTime.isDateTime(value)) {
            return value.toLocaleString(luxon_1.DateTime.DATE_SHORT);
        }
        if (value.length) {
            return value.length > 1
                ? `${value.length} selected`
                : value[0].toString();
        }
    }
    return value?.toString() || "";
};
exports.getDisplayedFilterValue = getDisplayedFilterValue;
